<lms-breadcrumb></lms-breadcrumb>
<lms-toolbar [options]="{ list: { listId: listId, skeletor: true } }">
  <div class="lms-toolbar__item" tools-actions>
    <gl-button
      color-primary
      title="{{ 'games.create' | translate }}"
      [text]="'games.create' | translate"
      [routerLink]="['/games/new']"
    ></gl-button>
  </div>
</lms-toolbar>
<lms-games-list [listId]="listId"></lms-games-list>
